import * as jwt from "jwt-decode";

import { getAxiosInstance } from "@/axiosClient";

class AuthService {
  get axios() {
    return getAxiosInstance();
  }
  async login(email, password) {
    const deviceId = this.getDeviceId();
    const response = await this.axios.post("/api/auth/login", {
      email,
      password,
      deviceId,
    });
    const token = response.data;
    if (!token.isTemp) {
      await this.setToken(token);
    }
    return token;
  }

  async verifyTwoFactor(code, rememberDevice) {
    const deviceId = rememberDevice ? this.getDeviceId() : null;
    const tempToken = localStorage.getItem("tempToken");
    const response = await this.axios.post("/api/auth/verify-2fa", {
      code,
      tempToken,
      deviceId,
    });
    const token = response.data;
    await this.setToken(token);
  }

  async setToken(token) {
    localStorage.removeItem("tempToken");
    localStorage.setItem("token", token.value);
    const user = await this.getCurrentUser();
    localStorage.setItem("user-id", user.id);
  }

  async resendCode() {
    const tempToken = localStorage.getItem("tempToken");
    const response = await this.axios.post("/api/auth/resend-2fa", {
      tempToken,
    });
    return response.data;
  }

  logout() {
    window.dispatchEvent(new CustomEvent("logout"));
  }

  async getCurrentUser() {
    const token = localStorage.getItem("token");
    if (!token) {
      return null;
    }
    if (token && this.isTokenExpiring(token)) {
      const newToken = await this.refreshToken();
      localStorage.setItem("token", newToken);
      return jwt.jwtDecode(newToken);
    }
    return jwt.jwtDecode(token);
  }

  isTokenExpiring(token) {
    try {
      const decoded = jwt.jwtDecode(token);
      const exp = decoded.exp * 1000; // JWT exp en segundos, por lo que multiplicamos por 1000
      return exp - Date.now() < 10 * 60 * 1000; // Considerar expiring si quedan menos de 10 minutos
    } catch (error) {
      return false;
    }
  }

  refreshToken() {
    return this.axios
      .post("/api/auth/refresh-token")
      .then((response) => response.data);
  }

  getDeviceId() {
    const deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      const newDeviceId = this.generateDeviceId();
      localStorage.setItem("deviceId", newDeviceId);
      return newDeviceId;
    }
    return deviceId;
  }

  generateDeviceId() {
    const randomValues = new Uint32Array(4);
    window.crypto.getRandomValues(randomValues);
    return Array.from(randomValues, (value) =>
      ("00000000" + value.toString(16)).slice(-8),
    ).join("-");
  }
}

export default new AuthService();
